import type { AccessTokenProvider, AllowedHostsValidator } from '@microsoft/kiota-abstractions';
import { AllowedHostsValidator as DefaultAllowedHostsValidator } from '@microsoft/kiota-abstractions';
import { msalInstance, tokenRequest } from '@/app/auth/msal-config.ts';

export class MsalAccessTokenProvider implements AccessTokenProvider {
  private readonly allowedHostsValidator: AllowedHostsValidator;

  constructor(allowedHosts: Set<string>) {
    if (allowedHosts.size === 0) {
      throw new Error('At least one API host must be allow-listed for MSAL token requests.');
    }

    this.allowedHostsValidator = new DefaultAllowedHostsValidator(allowedHosts);
  }

  public async getAuthorizationToken(url?: string): Promise<string> {
    if (!url || !this.allowedHostsValidator.isUrlHostValid(new URL(url, window.location.origin).href)) {
      throw new Error(`Refusing to acquire an access token for an unapproved API URL: ${url ?? '(missing URL)'}`);
    }

    const activeAccount = msalInstance.getActiveAccount();
    if (!activeAccount) {
      throw new Error('Cannot acquire an API access token without an active signed-in account.');
    }

    const response = await msalInstance.acquireTokenSilent({
      ...tokenRequest,
      account: activeAccount,
    });

    return response.accessToken;
  }

  public getAllowedHostsValidator(): AllowedHostsValidator {
    return this.allowedHostsValidator;
  }
}
